import React, { memo, useMemo } from "react";
import MultiSelect from "../../components/common/MultiSelect";
import { Icons } from "../../constants/icon-library";
import { getParticipantSecondary } from "./Meetings.utils";

const ParticipantsSection = memo(
  ({
    participants,
    selectedParticipants,
    onParticipantsChange,
    setShowAddParticipant,
  }) => {
    const options = useMemo(
      () =>
        participants.map((p) => ({
          value: p.uuid,
          label: `${p.name} (${getParticipantSecondary(p)})`,
        })),
      [participants],
    );

    return (
      <div className="mb-5">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h5 className="text-body-highlight mb-0">Participants</h5>

          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-1"
            type="button"
            onClick={() => setShowAddParticipant(true)}
          >
            <i className={`wb ${Icons("add")} fs-8 align-middle`} />
            Add Participant
          </button>
        </div>

        <MultiSelect
          options={options}
          value={selectedParticipants || []}
          onChange={onParticipantsChange}
          placeholder="Select participants..."
        />
      </div>
    );
  },
  (prev, next) =>
    prev.participants === next.participants &&
    prev.selectedParticipants === next.selectedParticipants,
);

export default ParticipantsSection;
